import styled from 'styled-components';

export const Button = styled.button`
  padding: 0;
  background-color: transparent;
  cursor: pointer;
  border: none;
  text-align: inherit;

  &,
  &:active,
  &:visited {
    color: var(--link);
    font-weight: normal;
    user-select: text;
    text-decoration: none;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      bottom: -2px;
      right: 0;
      width: 0;
      height: 1px;
      background-color: var(--link-hover);
      transition: width 0.3s cubic-bezier(0.25, 1, 0.5, 1);
    }
  }

  &:hover {
    color: var(--link-hover);

    &::before {
      left: 0;
      right: auto;
      width: 100%;
    }
  }

  &:focus {
    outline: none;
  }
`;
